<h2 mat-dialog-title>
    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <div style="display: flex; align-items: center; gap: 8px;">
            <mat-icon color="primary">
                {{ getContentTypeIcon() }}
            </mat-icon>
            <span>{{ product.productName }}</span>
        </div>

        <div class="combo-logo-container" *ngIf="properties.webUrl?.includes('sharepoint.com')">
            <img src="assets/img/sharepoint-logo.png" class="sharepoint-logo" alt="SharePoint Logo">
            <div class="combo-divider"></div>
            <mat-icon class="content-type-icon">
                {{ getContentTypeIcon() }}
            </mat-icon>
        </div>
    </div>
</h2>

<mat-dialog-content class="mat-typography">
    <!-- Image Viewer Section -->
    <div class="image-viewer-container" *ngIf="product.fileId || product.pictureUrl">

        <!-- SharePoint Badge on Image -->
        <div class="image-sharepoint-badge" *ngIf="properties.webUrl?.includes('sharepoint.com')">
            <img src="assets/img/sharepoint-logo.png" alt="SharePoint">
        </div>
    </div>

    <mat-list>
        <div mat-subheader>Allgemeine Informationen</div>

        <mat-list-item>
            <mat-icon mat-list-icon>business</mat-icon>
            <div mat-line class="info-label">Organisation</div>
            <div mat-line class="info-value">{{ product.subscript }}</div>
        </mat-list-item>

        <mat-list-item *ngIf="properties.dataDescription || properties.DataDesc">
            <mat-icon mat-list-icon>description</mat-icon>
            <div mat-line class="info-label">Beschreibung</div>
            <div mat-line class="info-value">{{ properties.dataDescription || properties.DataDesc }}</div>
        </mat-list-item>

        <mat-divider style="margin: 16px 0;"></mat-divider>
        <div mat-subheader>EDC Eigenschaften</div>

        <mat-list-item *ngIf="properties.name">
            <mat-icon mat-list-icon>badge</mat-icon>
            <div mat-line class="info-label">Dateiname</div>
            <div mat-line class="info-value">{{ properties.name }}</div>
        </mat-list-item>

        <mat-list-item *ngIf="properties.createdBy?.user">
            <mat-icon mat-list-icon>person</mat-icon>
            <div mat-line class="info-label">Erstellt von</div>
            <div mat-line class="info-value">
                {{ properties.createdBy.user.displayName }}
                <span *ngIf="properties.createdBy.user.email" class="text-on-surface-muted">({{
                    properties.createdBy.user.email }})</span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="properties.createdDateTime">
            <mat-icon mat-list-icon>calendar_today</mat-icon>
            <div mat-line class="info-label">Erstellt am</div>
            <div mat-line class="info-value">{{ properties.createdDateTime | date:'medium' }}</div>
        </mat-list-item>

        <mat-list-item *ngIf="properties.lastModifiedDateTime">
            <mat-icon mat-list-icon>update</mat-icon>
            <div mat-line class="info-label">Zuletzt geändert am</div>
            <div mat-line class="info-value">{{ properties.lastModifiedDateTime | date:'medium' }}</div>
        </mat-list-item>

        <mat-list-item *ngIf="properties.size">
            <mat-icon mat-list-icon>data_usage</mat-icon>
            <div mat-line class="info-label">Knotengröße</div>
            <div mat-line class="info-value">{{ formatSize(properties.size) }}</div>
        </mat-list-item>

        <mat-list-item *ngIf="properties.contenttype">
            <mat-icon mat-list-icon>category</mat-icon>
            <div mat-line class="info-label">Inhaltstyp</div>
            <div mat-line class="info-value">{{ properties.contenttype }}</div>
        </mat-list-item>

        <mat-list-item *ngIf="properties.webUrl">
            <mat-icon mat-list-icon>link</mat-icon>
            <div mat-line class="info-label">Web-URL</div>
            <div mat-line class="info-value">
                <a [href]="properties.webUrl" target="_blank">{{ properties.webUrl }}</a>
            </div>
        </mat-list-item>
    </mat-list>

    <mat-accordion style="margin-top: 24px; display: block;">
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Erweiterte Eigenschaften (Rohdaten)
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="asset-properties-container">
                <div class="property-row" *ngFor="let prop of getAdvancedPropertyKeys()">
                    <div class="property-key">{{ prop }}</div>
                    <div class="property-value">{{ formatValue(properties[prop]) }}</div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="close()">Schließen</button>
</div>
